import React, { useState } from 'react';
import DropDownButtonGlobal, { KeyValueFilterObject } from 'modules/Common/Components/DropDownButtonGlobal';
import { PERSONALITY_TYPES_DATA } from 'modules/Audience/constants';
import { DropDownIconsType } from 'modules/Common/Components/ToggleFilterButtonGlobal';
import { globalContactsSelectPersonalityTypesAction, listContactsSelectPersonalityTypeAction } from 'modules/Audience/Actions/contactsFiltersActions';
import { getQueryListId } from 'utils';
import { RootState } from 'store';
import { useSelector } from 'react-redux';

interface IStatusFilters {
  CompanyActiveFilterData: DropDownIconsType;
  CompanyFilterData: DropDownIconsType;
  CompanySelectedFilterData: DropDownIconsType;
  listDetailsSearchTerm: string;
}

const PersonalityTypeFilters: React.FC<IStatusFilters> = ({
  CompanyActiveFilterData,
  CompanyFilterData,
  CompanySelectedFilterData,
  listDetailsSearchTerm,
}) => {
  const globalContactsPersonalityTypeSelected = useSelector(
    (state: RootState) => state.contactsFilters.globalContactsFilters.selectedFilters.personalityType,
  );
  const listContactsPersonalityTypeSelected = useSelector(
    (state: RootState) => state.contactsFilters.listContactsFilters.selectedFilters.personalityType,
  );
  const globalAddToListMode = useSelector((state: RootState) => state.globalContacts.addToListGlobalMode);

  const isListView = globalAddToListMode ? null : getQueryListId();
  const [selectedFilters, setSelectedFilters] = useState<string[]>(isListView
    ? listContactsPersonalityTypeSelected : globalContactsPersonalityTypeSelected);
  const [selectAll, setSelectAll] = useState<boolean>(false);

  const handleClickCheckBox = (value: string, add: boolean) => {
    // console.log('handleClickCheckBox', value, add, selectedFilters);
    let newSelectedFilters: string[] = [];
    if (add) {
      newSelectedFilters = [...selectedFilters, value];
    } else {
      newSelectedFilters = selectedFilters.filter((item) => item !== value);
    }
    setSelectedFilters(newSelectedFilters);
    if (isListView) {
      if (listDetailsSearchTerm) {
        // If user is in Add To List view.
        listContactsSelectPersonalityTypeAction(newSelectedFilters, true, false);
        globalContactsSelectPersonalityTypesAction(newSelectedFilters, true, false);
      } else {
        listContactsSelectPersonalityTypeAction(newSelectedFilters, true, false);
      }
    } else {
      globalContactsSelectPersonalityTypesAction(newSelectedFilters, true, false);
    }
  };

  const handleSelectAll = (value: boolean) => {
    // console.log('handleSelectAll', value);
    setSelectedFilters(value ? PERSONALITY_TYPES_DATA.map((item) => item.value) : []);
    setSelectAll(value);
    if (isListView) {
      if (listDetailsSearchTerm) {
        // If user is in Add To List view.
        listContactsSelectPersonalityTypeAction(value ? PERSONALITY_TYPES_DATA.map((item) => item.value) : [], true, false);
        globalContactsSelectPersonalityTypesAction(value ? PERSONALITY_TYPES_DATA.map((item) => item.value) : [], true, false);
      } else {
        listContactsSelectPersonalityTypeAction(value ? PERSONALITY_TYPES_DATA.map((item) => item.value) : [], true, false);
      }
    } else {
      globalContactsSelectPersonalityTypesAction(value ? PERSONALITY_TYPES_DATA.map((item) => item.value) : [], true, false);
    }
  };

  return (
    <DropDownButtonGlobal
      title="Personality"
      personality
      // disable-next-line @typescript-eslint/no-unsafe-assignment
      btnData={CompanyFilterData}
      data={PERSONALITY_TYPES_DATA as KeyValueFilterObject[]}
      activeBtnData={CompanyActiveFilterData}
      selectedFiltersBtnData={CompanySelectedFilterData}
      selectedFilters={selectedFilters}
      onClickCheckBox={handleClickCheckBox}
      selectAll={selectAll}
      handleSelectAll={handleSelectAll}
    />
  );
};

export default PersonalityTypeFilters;
